import benchmarks from './benchmarks';
import lookup from './lookup';
import auth from './auth';
import jobHistory from './jobHistory';
import jobs from './jobs';
import admin from './admin';
import streams from './streams';

export const Api = {
  benchmarks,
  lookup,
  auth,
  jobHistory,
  jobs,
  admin,
  streams,
};
